export default __webpack_public_path__ + "static/media/win.948dcd9d.mp3";